export default __webpack_public_path__ + "static/media/aprova-180-banner.c0096a36.png";